import script from "./BoxVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./BoxVideo.vue?vue&type=script&setup=true&lang=js"

import "./BoxVideo.vue?vue&type=style&index=0&id=75d6cf40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75d6cf40"]])

export default __exports__